export default __webpack_public_path__ + "static/media/Pollo.eda7bc2b.jpg";